const KEY = "cdl_weak_areas"; // { questionId: { correct: number, wrong: number } }

export function updateWeakAreas(questions, answers) {
  const data = loadWeakAreas();
  questions.forEach((q, i) => {
    if (answers[i] === undefined) return;
    if (!data[q.id]) data[q.id] = { correct: 0, wrong: 0 };
    if (answers[i] === q.answer) data[q.id].correct++;
    else data[q.id].wrong++;
  });
  try { localStorage.setItem(KEY, JSON.stringify(data)); } catch {}
}

export function loadWeakAreas() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}

export function clearWeakAreas() {
  localStorage.removeItem(KEY);
}

// Returns the weakest questions from a bank, sorted worst first
export function getWeakQuestions(bank, limit = 50) {
  const data = loadWeakAreas();
  return bank
    .filter(q => data[q.id] && data[q.id].wrong > 0)
    .map(q => {
      const { correct, wrong } = data[q.id];
      return { q, accuracy: correct / (correct + wrong), wrong };
    })
    .sort((a, b) => a.accuracy - b.accuracy || b.wrong - a.wrong)
    .slice(0, limit)
    .map(x => x.q);
}

// Returns aggregate stats for a question bank
export function getWeakStats(bank) {
  const data = loadWeakAreas();
  let attempted = 0, withErrors = 0;
  bank.forEach(q => {
    const d = data[q.id];
    if (d && (d.correct + d.wrong) > 0) {
      attempted++;
      if (d.wrong > 0) withErrors++;
    }
  });
  return { attempted, withErrors, total: bank.length };
}
